//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.HiddenObjectsBuilder.js";
import "../Drawings/Drawings.ViewPlacementBuilder.js";
import "../Drawings/Drawings.ParentViewBuilder.js";
import "../Drawings/Drawings.ViewScaleBuilder.js";
import "../Drawings/Drawings.DraftingComponentSelectionBuilder.js";
import "../Drawings/Drawings.ViewStyleBuilder.js";
let d=[[[0,"Associative",1,0],[0,"BoundaryPoint1",1,"Point",0],[0,"BoundaryPoint2",1,"Point",0],[1,"HiddenObjects",0,"Drawings.HiddenObjectsBuilder",0],[0,"LabelOnParent",1,0],[1,"NonSectionedObjects",0,"Drawings.HiddenObjectsBuilder",0],[1,"Origin",0,"Drawings.ViewPlacementBuilder",0],[1,"Parent",0,"Drawings.ParentViewBuilder",0],[1,"Scale",0,"Drawings.ViewScaleBuilder",0],[1,"SecondaryComponents",0,"Drawings.DraftingComponentSelectionBuilder",0],[1,"Style",0,"Drawings.ViewStyleBuilder",0],[0,"Type",1,0]],[[[],"CreatePreviewView",{R_:{detailViewPreview:"Drawings.DetailView"}},0,0]],[]];
SPLM.Drawings.DetailViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.DetailViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.DetailViewBuilder.Types = Object.freeze({
    "Undefined" : "Undefined", "Circular" : "Circular", "RectangleByCorners" : "RectangleByCorners", "RectangleByCenterAndCorner" : "RectangleByCenterAndCorner", "Custom" : "Custom"});

SPLM.Drawings.DetailViewBuilder.LabelOnParentType = Object.freeze({
    "None" : "None", "Circle" : "Circle", "Note" : "Note", "Label" : "Label", "Embedded" : "Embedded", "Boundary" : "Boundary", "LabelOnBoundary" : "LabelOnBoundary"});

export default SPLM;